import gql from 'graphql-tag'

export const fetchNews = news_id => {
	return {
		query: gql`
			query ($news_id: bigint!) {
				news: news_by_pk(id: $news_id) {
					title
					category_id
					country_id
					featured
					description
					body
					publishing_date
					roles: news_roles {
						id: rol_id
					}
					image {
						file_name
						mime
						url
						id
					}
				}
			}
		`,
		variables: { news_id }
	}
}
